import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { WebPopService, State } from '../services';

export const webApi = (webPop: WebPopService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (!state.system?.webApi)
        return of([state, currentState] as [Partial<State>, State]);
      const { saveToQ, url, additionalVars } = state.system.webApi;
      return webPop.api$(url, additionalVars).pipe(
        map(
          (data) =>
            [
              {
                ...state,
                ...{
                  system: {
                    ...state.system,
                    webApi: undefined,
                  },
                  answers: [
                    ...state.answers!.slice(0, saveToQ),
                    data,
                    ...state.answers!.slice(saveToQ + 1),
                  ],
                },
              },
              currentState,
            ] as [Partial<State>, State]
        )
      );
    })
  );
